export default "__VITE_ASSET__CXuoxAm0__"